import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "Hooks/UserContext";

const ProtectedRoute = ({children})=>{
const token = localStorage.getItem("token")
const role = localStorage.getItem("role")
// const user = JSON.parse(localStorage.getItem("user"))
const {user} = useContext(UserContext)
if (user !== null) {
    if (user.isFormSubmit === "0" || !user.isFormSubmit) {
        return <Navigate to="/driver_forms/submit" />;
    }
}
if(token && role==="user"){
    return children
}
return <Navigate to="/driver_forms/login" />

}
export default ProtectedRoute